import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLanguage = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M21 12C21 7.018 16.982 3 12 3C7.018 3 3 7.018 3 12M21 12C21 16.982 16.982 21 12 21C7.018 21 3 16.982 3 12M21 12H3M10.168 4.06C7.278 8.885 7.278 15.116 10.168 19.941C11.014 21.354 12.987 21.354 13.833 19.941C16.723 15.116 16.723 8.885 13.833 4.06C12.986 2.647 11.014 2.647 10.168 4.06Z",
		stroke: "#111827",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
const ForwardRef = forwardRef(SvgLanguage);
export default ForwardRef;
